var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXli(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 107 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2092_57387)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.056 49.7428H0.0556641V55.2028H106.056V49.7428Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.056 44.2828H0.0556641V49.7428H106.056V44.2828Z",
    fill: "#D20037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.056 38.8228H0.0556641V44.2828H106.056V38.8228Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.056 55.2028H0.0556641V60.6628H106.056V55.2028Z",
    fill: "#D20037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.056 66.1328H0.0556641V71.5928H106.056V66.1328Z",
    fill: "#D20037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.056 60.6728H0.0556641V66.1328H106.056V60.6728Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.056 6.05278H0.0556641V11.5128H106.056V6.05278Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.056 0.592773H0.0556641V6.05277H106.056V0.592773Z",
    fill: "#D20037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.056 11.5128H0.0556641V16.9728H106.056V11.5128Z",
    fill: "#D20037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.056 22.4428H0.0556641V27.9028H106.056V22.4428Z",
    fill: "#D20037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.056 16.9828H0.0556641V22.4428H106.056V16.9828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.056 27.9028H0.0556641V33.3628H106.056V27.9028Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.056 33.3628H0.0556641V38.8228H106.056V33.3628Z",
    fill: "#D20037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9757 0.592773H0.0556641V38.8228H53.9757V0.592773Z",
    fill: "#002965"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.54578 2.41278L5.04578 3.94278H6.65578L5.35578 4.89278L5.85578 6.43278L4.54578 5.48278L3.23578 6.43278L3.73578 4.89278L2.42578 3.94278H4.04578L4.54578 2.41278Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.486 2.41278L49.986 3.94278H51.596L50.296 4.89278L50.796 6.43278L49.486 5.48278L48.176 6.43278L48.676 4.89278L47.376 3.94278H48.986L49.486 2.41278Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4957 2.41278L40.9957 3.94278H42.6157L41.3057 4.89278L41.8057 6.43278L40.4957 5.48278L39.1857 6.43278L39.6857 4.89278L38.3857 3.94278H39.9957L40.4957 2.41278Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5055 2.41278L32.0055 3.94278H33.6255L32.3155 4.89278L32.8155 6.43278L31.5055 5.48278L30.2055 6.43278L30.7055 4.89278L29.3955 3.94278H31.0155L31.5055 2.41278Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5262 2.41278L23.0262 3.94278H24.6362L23.3263 4.89278L23.8263 6.43278L22.5262 5.48278L21.2162 6.43278L21.7162 4.89278L20.4062 3.94278H22.0262L22.5262 2.41278Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.536 2.41278L14.036 3.94278H15.646L14.346 4.89278L14.836 6.43278L13.536 5.48278L12.226 6.43278L12.726 4.89278L11.416 3.94278H13.036L13.536 2.41278Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.54578 10.0528L5.04578 11.5928H6.65578L5.35578 12.5428L5.85578 14.0728L4.54578 13.1228L3.23578 14.0728L3.73578 12.5428L2.42578 11.5928H4.04578L4.54578 10.0528Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.486 10.0528L49.986 11.5928H51.596L50.296 12.5428L50.796 14.0728L49.486 13.1228L48.176 14.0728L48.676 12.5428L47.376 11.5928H48.986L49.486 10.0528Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4957 10.0528L40.9957 11.5928H42.6157L41.3057 12.5428L41.8057 14.0728L40.4957 13.1228L39.1857 14.0728L39.6857 12.5428L38.3857 11.5928H39.9957L40.4957 10.0528Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5055 10.0528L32.0055 11.5928H33.6255L32.3155 12.5428L32.8155 14.0728L31.5055 13.1228L30.2055 14.0728L30.7055 12.5428L29.3955 11.5928H31.0155L31.5055 10.0528Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5262 10.0528L23.0262 11.5928H24.6362L23.3263 12.5428L23.8263 14.0728L22.5262 13.1228L21.2162 14.0728L21.7162 12.5428L20.4062 11.5928H22.0262L22.5262 10.0528Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.536 10.0528L14.036 11.5928H15.646L14.346 12.5428L14.836 14.0728L13.536 13.1228L12.226 14.0728L12.726 12.5428L11.416 11.5928H13.036L13.536 10.0528Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.54578 17.6928L5.04578 19.2328H6.65578L5.35578 20.1828L5.85578 21.7228L4.54578 20.7728L3.23578 21.7228L3.73578 20.1828L2.42578 19.2328H4.04578L4.54578 17.6928Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.486 17.6928L49.986 19.2328H51.596L50.296 20.1828L50.796 21.7228L49.486 20.7728L48.176 21.7228L48.676 20.1828L47.376 19.2328H48.986L49.486 17.6928Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4957 17.6928L40.9957 19.2328H42.6157L41.3057 20.1828L41.8057 21.7228L40.4957 20.7728L39.1857 21.7228L39.6857 20.1828L38.3857 19.2328H39.9957L40.4957 17.6928Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5055 17.6928L32.0055 19.2328H33.6255L32.3155 20.1828L32.8155 21.7228L31.5055 20.7728L30.2055 21.7228L30.7055 20.1828L29.3955 19.2328H31.0155L31.5055 17.6928Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5262 17.6928L23.0262 19.2328H24.6362L23.3263 20.1828L23.8263 21.7228L22.5262 20.7728L21.2162 21.7228L21.7162 20.1828L20.4062 19.2328H22.0262L22.5262 17.6928Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.536 17.6928L14.036 19.2328H15.646L14.346 20.1828L14.836 21.7228L13.536 20.7728L12.226 21.7228L12.726 20.1828L11.416 19.2328H13.036L13.536 17.6928Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.54578 25.3428L5.04578 26.8728H6.65578L5.35578 27.8228L5.85578 29.3628L4.54578 28.4128L3.23578 29.3628L3.73578 27.8228L2.42578 26.8728H4.04578L4.54578 25.3428Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.486 25.3428L49.986 26.8728H51.596L50.296 27.8228L50.796 29.3628L49.486 28.4128L48.176 29.3628L48.676 27.8228L47.376 26.8728H48.986L49.486 25.3428Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4957 25.3428L40.9957 26.8728H42.6157L41.3057 27.8228L41.8057 29.3628L40.4957 28.4128L39.1857 29.3628L39.6857 27.8228L38.3857 26.8728H39.9957L40.4957 25.3428Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5055 25.3428L32.0055 26.8728H33.6255L32.3155 27.8228L32.8155 29.3628L31.5055 28.4128L30.2055 29.3628L30.7055 27.8228L29.3955 26.8728H31.0155L31.5055 25.3428Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5262 25.3428L23.0262 26.8728H24.6362L23.3263 27.8228L23.8263 29.3628L22.5262 28.4128L21.2162 29.3628L21.7162 27.8228L20.4062 26.8728H22.0262L22.5262 25.3428Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.536 25.3428L14.036 26.8728H15.646L14.346 27.8228L14.836 29.3628L13.536 28.4128L12.226 29.3628L12.726 27.8228L11.416 26.8728H13.036L13.536 25.3428Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.54578 32.9828L5.04578 34.5228H6.65578L5.35578 35.4728L5.85578 37.0028L4.54578 36.0528L3.23578 37.0028L3.73578 35.4728L2.42578 34.5228H4.04578L4.54578 32.9828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.486 32.9828L49.986 34.5228H51.596L50.296 35.4728L50.796 37.0028L49.486 36.0528L48.176 37.0028L48.676 35.4728L47.376 34.5228H48.986L49.486 32.9828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4957 32.9828L40.9957 34.5228H42.6157L41.3057 35.4728L41.8057 37.0028L40.4957 36.0528L39.1857 37.0028L39.6857 35.4728L38.3857 34.5228H39.9957L40.4957 32.9828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5055 32.9828L32.0055 34.5228H33.6255L32.3155 35.4728L32.8155 37.0028L31.5055 36.0528L30.2055 37.0028L30.7055 35.4728L29.3955 34.5228H31.0155L31.5055 32.9828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5262 32.9828L23.0262 34.5228H24.6362L23.3263 35.4728L23.8263 37.0028L22.5262 36.0528L21.2162 37.0028L21.7162 35.4728L20.4062 34.5228H22.0262L22.5262 32.9828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.536 32.9828L14.036 34.5228H15.646L14.346 35.4728L14.836 37.0028L13.536 36.0528L12.226 37.0028L12.726 35.4728L11.416 34.5228H13.036L13.536 32.9828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.996 29.1628L45.496 30.7028H47.106L45.796 31.6528L46.296 33.1828L44.996 32.2328L43.686 33.1828L44.186 31.6528L42.876 30.7028H44.496L44.996 29.1628Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0057 29.1628L36.5057 30.7028H38.1157L36.8157 31.6528L37.3157 33.1828L36.0057 32.2328L34.6957 33.1828L35.1957 31.6528L33.8857 30.7028H35.5057L36.0057 29.1628Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0155 29.1628L27.5155 30.7028H29.1255L27.8255 31.6528L28.3255 33.1828L27.0155 32.2328L25.7055 33.1828L26.2055 31.6528L24.8955 30.7028H26.5155L27.0155 29.1628Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.026 29.1628L18.526 30.7028H20.146L18.836 31.6528L19.336 33.1828L18.026 32.2328L16.716 33.1828L17.216 31.6528L15.916 30.7028H17.526L18.026 29.1628Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.03578 29.1628L9.53578 30.7028H11.1558L9.84578 31.6528L10.3458 33.1828L9.03578 32.2328L7.73578 33.1828L8.23578 31.6528L6.92578 30.7028H8.54578L9.03578 29.1628Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.996 21.5228L45.496 23.0528H47.106L45.796 24.0028L46.296 25.5428L44.996 24.5928L43.686 25.5428L44.186 24.0028L42.876 23.0528H44.496L44.996 21.5228Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0057 21.5228L36.5057 23.0528H38.1157L36.8157 24.0028L37.3157 25.5428L36.0057 24.5928L34.6957 25.5428L35.1957 24.0028L33.8857 23.0528H35.5057L36.0057 21.5228Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0155 21.5228L27.5155 23.0528H29.1255L27.8255 24.0028L28.3255 25.5428L27.0155 24.5928L25.7055 25.5428L26.2055 24.0028L24.8955 23.0528H26.5155L27.0155 21.5228Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.026 21.5228L18.526 23.0528H20.146L18.836 24.0028L19.336 25.5428L18.026 24.5928L16.716 25.5428L17.216 24.0028L15.916 23.0528H17.526L18.026 21.5228Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.03578 21.5228L9.53578 23.0528H11.1558L9.84578 24.0028L10.3458 25.5428L9.03578 24.5928L7.73578 25.5428L8.23578 24.0028L6.92578 23.0528H8.54578L9.03578 21.5228Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.996 13.8728L45.496 15.4128H47.106L45.796 16.3628L46.296 17.9028L44.996 16.9528L43.686 17.9028L44.186 16.3628L42.876 15.4128H44.496L44.996 13.8728Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0057 13.8728L36.5057 15.4128H38.1157L36.8157 16.3628L37.3157 17.9028L36.0057 16.9528L34.6957 17.9028L35.1957 16.3628L33.8857 15.4128H35.5057L36.0057 13.8728Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0155 13.8728L27.5155 15.4128H29.1255L27.8255 16.3628L28.3255 17.9028L27.0155 16.9528L25.7055 17.9028L26.2055 16.3628L24.8955 15.4128H26.5155L27.0155 13.8728Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.026 13.8728L18.526 15.4128H20.146L18.836 16.3628L19.336 17.9028L18.026 16.9528L16.716 17.9028L17.216 16.3628L15.916 15.4128H17.526L18.026 13.8728Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.03578 13.8728L9.53578 15.4128H11.1558L9.84578 16.3628L10.3458 17.9028L9.03578 16.9528L7.73578 17.9028L8.23578 16.3628L6.92578 15.4128H8.54578L9.03578 13.8728Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.996 6.23279L45.496 7.77279H47.106L45.796 8.72279L46.296 10.2528L44.996 9.30279L43.686 10.2528L44.186 8.72279L42.876 7.77279H44.496L44.996 6.23279Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0057 6.23279L36.5057 7.77279H38.1157L36.8157 8.72279L37.3157 10.2528L36.0057 9.30279L34.6957 10.2528L35.1957 8.72279L33.8857 7.77279H35.5057L36.0057 6.23279Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0155 6.23279L27.5155 7.77279H29.1255L27.8255 8.72279L28.3255 10.2528L27.0155 9.30279L25.7055 10.2528L26.2055 8.72279L24.8955 7.77279H26.5155L27.0155 6.23279Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.026 6.23279L18.526 7.77279H20.146L18.836 8.72279L19.336 10.2528L18.026 9.30279L16.716 10.2528L17.216 8.72279L15.916 7.77279H17.526L18.026 6.23279Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.03578 6.23279L9.53578 7.77279H11.1558L9.84578 8.72279L10.3458 10.2528L9.03578 9.30279L7.73578 10.2528L8.23578 8.72279L6.92578 7.77279H8.54578L9.03578 6.23279Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2092_57387)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.0557 36.5928C78.0557 50.3977 66.8666 61.5928 53.0557 61.5928C51.3788 61.5928 49.7325 61.4281 48.1471 61.1111C36.6898 58.8306 28.0557 48.7208 28.0557 36.5928C28.0557 22.7818 39.2508 11.5928 53.0557 11.5928C66.8605 11.5928 77.3788 22.1172 78.0252 35.3489C78.0435 35.7574 78.0557 36.1781 78.0557 36.5928Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8051 44.0562L71.799 45.2513L55.5551 54.6842L46.9697 49.733L46.9819 48.5379L63.2197 39.0989L71.8051 44.0562Z",
    fill: "#C9CEE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4945 41.9891C43.0555 42.3306 43.6957 42.5257 44.4091 42.5623L50.0433 45.8367C51.4701 45.5928 52.9701 46.0135 54.025 47.4099C55.3664 46.983 56.7079 46.544 58.0616 46.1477C62.1835 44.9342 66.1042 43.4038 70.1225 42.0074C70.6042 40.6964 70.8908 39.3611 70.8847 38.1111C70.8847 36.916 70.6286 35.9403 70.1835 35.2025L68.6652 32.1172C68.2689 31.3367 67.7201 30.7513 67.0555 30.3611L66.3237 29.9342C65.2933 29.3306 63.964 29.233 62.4823 29.7025L61.7567 29.2757V28.2452L59.5981 27.0013V25.9281L55.3359 23.4647L55.1408 23.5806C54.7445 23.0257 54.2262 22.605 53.6408 22.3306C53.7445 22.3794 53.842 22.4342 53.9457 22.4891L48.0067 19.044C46.5555 18.2025 44.5311 18.3184 42.3055 19.605C37.8786 22.1599 34.2994 28.355 34.3116 33.4464C34.3177 35.9769 35.2079 37.7574 36.6469 38.5928L42.4762 41.9769C42.4762 41.9769 42.4945 41.983 42.5006 41.9952L42.4945 41.9891Z",
    fill: "#57B3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7986 44.0562V45.2452L55.5547 54.6842L55.5608 53.4952L71.7986 44.0562Z",
    fill: "#C9CEE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5612 53.4952L55.5551 54.6842L46.9697 49.733L46.9758 48.5379L55.5612 53.4952Z",
    fill: "#B0B8CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7988 44.0562L55.561 53.4952L46.9756 48.5379L63.2195 39.0989L71.7988 44.0562Z",
    fill: "#E3E7F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0364 52.6233L49.3047 49.8733V49.4403L54.0364 52.1903C54.1705 52.3184 54.1462 52.4647 54.0364 52.6233Z",
    fill: "#4C5C75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0305 52.1903L49.2988 49.4403L49.9879 48.1964L54.7196 50.9464C54.8354 51.3428 54.4757 51.7635 54.0305 52.1903Z",
    fill: "#111D33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.72 50.9525L49.9883 48.2025L62.3968 41.0684L67.1285 43.8184C62.3724 47.0562 56.4456 51.9099 54.72 50.9525Z",
    fill: "#4C5C75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1278 43.8184L67.823 44.2635V44.6964L54.0364 52.6233L54.0303 52.1903L54.7193 50.9525L67.1278 43.8184Z",
    fill: "#1D2943"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9332 22.483C52.4759 21.6355 53.1771 27.233 50.9454 28.5196C46.5186 31.0745 43.4271 32.1416 43.4393 37.233C43.4454 39.7635 41.1284 41.1964 42.5674 42.0318L36.6345 38.5867C35.1954 37.7513 34.2991 35.9708 34.293 33.4403C34.2808 28.3489 37.8601 22.1538 42.2869 19.5928C44.5186 18.3062 46.5369 18.1842 47.9942 19.0318L53.9271 22.4769L53.9332 22.483Z",
    fill: "#57B3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2261 23.044C52.6529 20.4891 56.2566 22.5379 56.2749 27.6294C56.2871 32.7208 52.7078 38.922 48.281 41.4769C43.8542 44.0318 40.2505 41.983 40.2383 36.8916C40.2261 31.8001 43.7993 25.605 48.2322 23.044H48.2261Z",
    fill: "#497BFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2383 48.7208L43.5371 41.922V41.544L55.2383 48.3428V48.7208Z",
    fill: "#5094FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2383 48.3428L43.5371 41.544L52.3176 36.4769L64.0188 43.2757L55.2383 48.3428Z",
    fill: "#57B3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0188 43.2757V43.6537L55.2383 48.7208V48.3428L64.0188 43.2757Z",
    fill: "#497BFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9764 48.1233L42.2812 41.3245V40.9464L53.9764 47.7452V48.1233Z",
    fill: "#5094FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9764 47.7452L42.2812 40.9464L53.5861 34.422L65.2873 41.2147L53.9764 47.7452Z",
    fill: "#57B3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2875 41.2147V41.5928L53.9766 48.1233V47.7452L65.2875 41.2147Z",
    fill: "#497BFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.159 47.2696L41.4639 40.4708V40.0989L53.159 46.8916V47.2696Z",
    fill: "#5094FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.159 46.8916L41.4639 40.0989L54.4273 32.6111L66.1224 39.4098L53.159 46.8916Z",
    fill: "#57B3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1226 39.4099V39.7879L53.1592 47.2696V46.8916L66.1226 39.4099Z",
    fill: "#497BFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5792 46.2818L40.8779 39.483V39.105L52.5792 45.9037V46.2818Z",
    fill: "#5094FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5792 45.9037L40.8779 39.105L55.006 30.9464L66.7072 37.7452L52.5792 45.9037Z",
    fill: "#57B3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7071 37.7452V38.1233L52.5791 46.2818V45.9037L66.7071 37.7452Z",
    fill: "#497BFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2081 45.172L40.5068 38.3733V37.9952L52.2081 44.794V45.172Z",
    fill: "#5094FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2081 44.794L40.5068 37.9952L55.3605 29.422L67.0617 36.2147L52.2081 44.794Z",
    fill: "#57B3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0617 36.2147V36.5928L52.208 45.172V44.794L67.0617 36.2147Z",
    fill: "#497BFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0369 43.9403L40.3418 37.1416V36.7635L52.0369 43.5623V43.9403Z",
    fill: "#5094FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0369 43.5623L40.3418 36.7635L55.5003 28.0135L67.2016 34.8123L52.0369 43.5623Z",
    fill: "#57B3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2017 34.8123V35.1903L52.0371 43.9403V43.5623L67.2017 34.8123Z",
    fill: "#497BFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0489 42.6111L40.3477 35.8123V35.4342L52.0489 42.233V42.6111Z",
    fill: "#5094FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0489 42.233L40.3477 35.4342L55.4879 26.6964L67.183 33.4952L52.0489 42.233Z",
    fill: "#57B3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.183 33.4952V33.8733L52.0488 42.6111V42.233L67.183 33.4952Z",
    fill: "#497BFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2684 41.1598L40.5732 34.3611V33.983L52.2684 40.7818V41.1598Z",
    fill: "#5094FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2684 40.7818L40.5732 33.983L55.2684 25.4952L66.9635 32.294L52.2684 40.7818Z",
    fill: "#57B3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9637 32.294V32.672L52.2686 41.1598V40.7818L66.9637 32.294Z",
    fill: "#497BFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2192 32.8001L51.4448 27.7025L51.4326 23.8367L60.207 28.9342L60.2192 32.8001Z",
    fill: "#5094FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.207 28.9342L51.4326 23.8367L51.7863 23.6294L60.5607 28.733L60.207 28.9342Z",
    fill: "#57B3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5607 28.733L60.5729 32.5989L60.2192 32.8001L60.207 28.9342L60.5607 28.733Z",
    fill: "#538BC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0669 33.4647L50.2925 28.3672L50.2803 23.6842L59.0547 28.7818L59.0669 33.4647Z",
    fill: "#5094FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0547 28.7818L50.2803 23.6842L50.6339 23.483L59.4083 28.5806L59.0547 28.7818Z",
    fill: "#57B3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4083 28.5806L59.4205 33.2635L59.0669 33.4647L59.0547 28.7818L59.4083 28.5806Z",
    fill: "#538BC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9145 34.1294L49.1401 29.0318L49.1279 23.8733L57.9023 28.9769L57.9145 34.1294Z",
    fill: "#5094FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9023 28.9769L49.1279 23.8733L49.4816 23.672L58.256 28.7696L57.9023 28.9769Z",
    fill: "#57B3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.256 28.7696L58.2682 33.9281L57.9145 34.1294L57.9023 28.9769L58.256 28.7696Z",
    fill: "#538BC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7622 34.794L47.9939 29.6964L47.9756 24.3306L56.75 29.4281L56.7622 34.794Z",
    fill: "#5094FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.75 29.4281L47.9756 24.3306L48.3292 24.1294L57.1036 29.2269L56.75 29.4281Z",
    fill: "#57B3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1037 29.2269L57.1159 34.5928L56.7622 34.794L56.75 29.4281L57.1037 29.2269Z",
    fill: "#538BC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6159 35.4586L46.8415 30.3611L46.8232 24.9952L55.5976 30.0989L55.6159 35.4586Z",
    fill: "#5094FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5976 30.0989L46.8232 24.9952L47.1769 24.794L55.9513 29.8916L55.5976 30.0989Z",
    fill: "#57B3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9513 29.8916L55.9635 35.2574L55.616 35.4586L55.5977 30.0989L55.9513 29.8916Z",
    fill: "#538BC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4636 36.1233L45.6892 31.0257L45.6709 25.9037L54.4453 31.0013L54.4636 36.1233Z",
    fill: "#5094FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4453 31.0013L45.6709 25.9037L46.0246 25.6964L54.7989 30.8001L54.4453 31.0013Z",
    fill: "#57B3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.799 30.8001L54.8112 35.922L54.4636 36.1233L54.4453 31.0013L54.799 30.8001Z",
    fill: "#538BC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.311 36.7879L44.5366 31.6903L44.5244 27.0196L53.2988 32.1172L53.311 36.7879Z",
    fill: "#5094FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2988 32.1172L44.5244 27.0196L44.872 26.8184L53.6464 31.916L53.2988 32.1172Z",
    fill: "#57B3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6464 31.916L53.6586 36.5867L53.311 36.7879L53.2988 32.1172L53.6464 31.916Z",
    fill: "#538BC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1587 37.4525L43.3843 32.355L43.3721 28.4403L52.1465 33.5379L52.1587 37.4525Z",
    fill: "#5094FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1465 33.5379L43.3721 28.4403L43.7257 28.2391L52.5001 33.3367L52.1465 33.5379Z",
    fill: "#57B3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5001 33.3367L52.5123 37.2513L52.1587 37.4525L52.1465 33.5379L52.5001 33.3367Z",
    fill: "#538BC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7503 28.2391L61.7381 33.8245L53.8418 38.4159L53.8479 32.8306L61.7503 28.2391Z",
    fill: "#497BFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.848 32.8306L53.8419 38.4159L47.6895 34.8672L47.7016 29.2757L53.848 32.8306Z",
    fill: "#5094FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.75 28.2391L53.8475 32.8306L47.7012 29.2757L55.5975 24.6842L61.75 28.2391Z",
    fill: "#57B3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5977 25.922L59.5855 28.8306L54.1099 32.0074L49.8477 29.5501V26.6416L55.3294 23.4647L59.5977 25.922Z",
    fill: "#C9CEE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5982 25.922L59.5921 28.8245L54.1104 32.0074L54.1165 29.105L59.5982 25.922Z",
    fill: "#C9CEE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1162 29.105L54.1101 32.0074L49.8418 29.544L49.8479 26.6416L54.1162 29.105Z",
    fill: "#B0B8CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5977 25.922L54.1159 29.105L49.8477 26.6416L55.3294 23.4586L59.5977 25.922Z",
    fill: "#E3E7F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0616 30.3611C65.6287 29.5318 63.647 29.6477 61.4641 30.9099C57.1165 33.416 53.6104 39.5013 53.6226 44.4952C53.6287 46.9769 54.5067 48.7208 55.9153 49.544L55.1775 49.1172C53.7628 48.294 52.8909 46.5501 52.8848 44.0684C52.8726 39.0745 56.3787 32.9952 60.7263 30.483C62.9153 29.2208 64.8909 29.105 66.3238 29.9342L67.0616 30.3611Z",
    fill: "#5094FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4584 30.9099C65.806 28.4038 69.3365 30.416 69.3548 35.4099C69.3731 40.4038 65.8548 46.483 61.5133 48.9952C57.1719 51.5074 53.6353 49.4891 53.6231 44.4952C53.6109 39.5013 57.117 33.4221 61.4645 30.9099H61.4584Z",
    fill: "#57B3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2321 31.7086C49.8357 32.0562 50.3175 32.8977 50.3175 33.5867C50.3175 34.2757 49.8297 34.5562 49.226 34.2086C48.6223 33.8611 48.1406 33.0196 48.1406 32.3306C48.1406 31.6416 48.6345 31.3611 49.2321 31.7086Z",
    fill: "#1D2943"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0842 36.0655C53.5094 35.8185 53.5083 35.0234 53.082 34.2897C52.6556 33.5559 51.9653 33.1614 51.5402 33.4084C51.1151 33.6554 51.1161 34.4505 51.5425 35.1842C51.9689 35.918 52.6591 36.3125 53.0842 36.0655Z",
    fill: "#1D2943"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1834 35.2025L68.6652 32.1172L65.2871 34.1355L68.1713 36.7879L70.1834 35.2025Z",
    fill: "#57B3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8237 47.7452V49.8611L58.2811 50.0623L55.0859 46.7818L61.8237 47.7452Z",
    fill: "#57B3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.561 34.5074C68.0427 32.4952 70.872 34.1111 70.8842 38.1111C70.8964 42.1111 68.0793 46.983 64.5976 48.9952C61.1159 51.0074 58.2866 49.3916 58.2745 45.3916C58.2623 41.3916 61.0732 36.5196 64.5549 34.5074H64.561Z",
    fill: "#5094FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6221 42.4464C66.9209 41.8428 67.116 41.1964 67.1709 40.5928L68.2501 39.9708C68.1891 40.922 67.8782 41.9403 67.3904 42.8855L66.6282 42.4525L66.6221 42.4464Z",
    fill: "#1D2943"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8789 44.5562C65.3789 44.2025 65.8423 43.7086 66.2143 43.1477L66.9765 43.5806C66.4033 44.4769 65.6777 45.2574 64.8789 45.794V44.5562Z",
    fill: "#1D2943"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9516 40.355L62.1895 39.9159C62.7626 39.0196 63.4882 38.2391 64.287 37.7086V38.9464C63.787 39.3001 63.3297 39.794 62.9577 40.355H62.9516Z",
    fill: "#1D2943"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9941 43.5745C62.0489 44.1172 62.2502 44.5318 62.555 44.794L61.7989 46.1111C61.305 45.733 60.988 45.0806 60.9209 44.2025L62.0002 43.5806L61.9941 43.5745Z",
    fill: "#1D2943"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.208 46.3428L62.9641 45.0257C63.3422 45.1538 63.7995 45.1172 64.3056 44.8916V46.1294C63.5129 46.5196 62.7812 46.5745 62.208 46.3428Z",
    fill: "#1D2943"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5431 41.0562C62.2443 41.6599 62.0492 42.3001 61.9943 42.9099L60.915 43.5318C60.976 42.5806 61.287 41.5623 61.7748 40.6172L62.537 41.0501L62.5431 41.0562Z",
    fill: "#1D2943"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1713 39.9221C67.1165 39.3794 66.9152 38.9647 66.6104 38.7025L67.3725 37.3855C67.8665 37.7635 68.1835 38.416 68.2506 39.294L67.1713 39.916V39.9221Z",
    fill: "#1D2943"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9638 37.1599L66.2016 38.4769C65.8235 38.3489 65.3662 38.3855 64.8662 38.6111V37.3733C65.6589 36.983 66.3906 36.9281 66.9638 37.1599Z",
    fill: "#1D2943"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0737 40.1537C65.7749 39.9769 65.3725 40.0257 64.9151 40.2879C64.0066 40.8123 63.281 42.0623 63.2871 43.105C63.2871 43.6233 63.4456 43.9891 63.7383 44.1659L63.2444 43.8794C62.9517 43.7086 62.7627 43.3428 62.7627 42.8245C62.7627 41.7818 63.4944 40.5074 64.4029 39.983C64.8603 39.7208 65.2749 39.6964 65.5737 39.8672L66.0676 40.1537H66.0737Z",
    fill: "#F3F1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9029 40.2696C65.8115 39.7452 66.5554 40.1659 66.5554 41.2086C66.5554 42.2513 65.8237 43.5257 64.9151 44.0501C64.0066 44.5745 63.2688 44.1537 63.2627 43.1111C63.2627 42.0684 63.9944 40.794 64.9029 40.2696Z",
    fill: "#DEDFFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1777 44.1354C63.7021 44.1354 63.4094 43.7391 63.4033 43.111C63.4033 42.111 64.1045 40.8915 64.9765 40.3915C65.2082 40.2574 65.4399 40.1842 65.6472 40.1842C66.1228 40.1842 66.4155 40.5745 66.4216 41.2086C66.4216 42.2086 65.7204 43.4281 64.8484 43.9281C64.6167 44.0623 64.385 44.1354 64.1777 44.1354Z",
    fill: "#4C5C75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8301 43.7757C71.0314 43.8915 71.0314 44.0745 70.8301 44.1903C70.635 44.3062 70.3119 44.3062 70.1167 44.1903C69.9155 44.0745 69.9155 43.8915 70.1167 43.7757C70.3119 43.6598 70.635 43.6598 70.8301 43.7757Z",
    fill: "#414F65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9517 43.5745C69.7749 43.4708 69.6042 43.5623 69.3359 43.7147C68.7993 44.0257 68.3542 44.6903 68.3542 45.3062C68.3542 45.6111 68.403 45.8367 68.5737 45.9342L64.3237 43.5074C64.1469 43.4038 64.0432 43.1903 64.0371 42.8855C64.0371 42.2696 64.47 41.5196 65.0066 41.2086C65.2749 41.0501 65.5188 41.0379 65.6956 41.1416L69.9456 43.5684L69.9517 43.5745Z",
    fill: "#E3E7F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9486 45.1526C70.3276 44.5004 70.328 43.7934 69.9494 43.5734C69.5709 43.3535 68.9568 43.7039 68.5778 44.3561C68.1988 45.0083 68.1985 45.7154 68.577 45.9353C68.9555 46.1553 69.5696 45.8048 69.9486 45.1526Z",
    fill: "#9EA9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9757 44.3428C69.9757 44.5623 69.8964 44.8062 69.7805 45.0135C69.6525 45.2452 69.4696 45.4525 69.2622 45.5684C68.872 45.794 68.5488 45.6172 68.5488 45.1598C68.5488 44.9342 68.6342 44.6781 68.7683 44.4464C68.8964 44.2269 69.0671 44.0379 69.2622 43.9281C69.6525 43.7025 69.9635 43.8916 69.9757 44.3367V44.3428Z",
    fill: "#1D2943"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7752 44.4525C68.641 44.6781 68.5557 44.9342 68.5557 45.1659C68.5557 45.6171 68.8788 45.8001 69.2691 45.5745C69.4703 45.4586 69.6532 45.2513 69.7813 45.0196L68.7691 44.4525H68.7752Z",
    fill: "#1D2943"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9766 44.3428C69.9766 43.8915 69.6595 43.7086 69.2632 43.9342C69.0742 44.044 68.8973 44.233 68.7754 44.4464L69.7876 45.0135C69.9095 44.8001 69.9827 44.5562 69.9827 44.3428H69.9766Z",
    fill: "#4C5C75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7988 48.2086C49 48.3245 49 48.5074 48.7988 48.6233C48.6037 48.7391 48.2805 48.7391 48.0793 48.6233C47.8842 48.5074 47.8781 48.3245 48.0793 48.2086C48.2744 48.0928 48.5976 48.0928 48.7927 48.2086H48.7988Z",
    fill: "#414F65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9327 52.3184C56.1339 52.4342 56.1339 52.6172 55.9327 52.733C55.7376 52.8489 55.4144 52.8489 55.2193 52.733C55.0181 52.6172 55.0181 52.4342 55.2193 52.3184C55.4144 52.2025 55.7376 52.2025 55.9327 52.3184Z",
    fill: "#414F65"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2092_57387"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 106,
    height: 71,
    fill: "white",
    transform: "translate(0.0556641 0.592773)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2092_57387"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(28.0557 11.5928)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXli);
export default __webpack_public_path__ + "static/media/XLI.cc400d2dc9fbd189d28c14ea379e403b.svg";
export { ForwardRef as ReactComponent };